module.exports = __webpack_public_path__ + "img/process-2.221e1941.svg";